import AppRoutes from './routes/web';
import './App.css';

// Screen CSS loads with each screen (home + lazy routes). Loading all upfront bloated
// the main chunk with ~18 KiB of unused CSS for screens the user may never visit.
import './screen/home/style.css';
import './screen/event/style.css';
import './screen/topPlayers/style.css';
import './screen/tipsandtricks/style.css';
import './screen/updates/style.css';
function App() {
  // LCP shell in index.html is kept; Home moves the img into its layout for "discoverable in initial document".
  // Non-Home routes remove the shell via LcpShellManager in routes/web.js.
  return (
    <div className="App">
      
       <AppRoutes />
    </div>
  );
}

export default App;
